import { SectionDataWeb } from '@nucleus/types/web';
import { createContext } from 'react';

export interface SectionContextValue {
  section: SectionDataWeb;
}
export const SectionContext = createContext<SectionContextValue>({} as SectionContextValue);
